import { InlineLink } from 'InlineLink';
import { type FC, memo } from 'react';

const MailtoLinkComponent: FC<{ className?: string; email: string }> = ({ className, email }) => (
    <InlineLink className={className} href={`mailto:${email}`}>
        {email}
    </InlineLink>
);

export const MailtoLink = memo(MailtoLinkComponent) as typeof MailtoLinkComponent;
